export const MIXPANEL_DECORATED_FIELD_NAME = 'mixpanelDecorated';
export const EVENT_SOURCE_FIELD_NAME = 'eventSource';
export const EVENT_TYPE_FIELD_NAME = 'eventType';
export const EVENT_CODE_FIELD_NAME = 'eventCode';
export const POSSIBLE_VALUES_FIELD_NAME = 'possibleValues';
